import SpinnerLoader from "../Loading/SpinnerLoader";
import { useBankFeeds } from "./bankFeedsAuthProvider";

export const SecureConnection = () => {
  const { orgInfo, showInstitutionMessage } = useBankFeeds();

  return (
    <div className="h-96 flex items-center justify-center">
      <div className={showInstitutionMessage ? "h-full" : ""}>
        <SpinnerLoader size={60} className="mb-[30px]" />

        {showInstitutionMessage && (
          <div className="text-center">
            <h1 className="font-bold text-xl text-[#212430] mb-[8px]">
              Contacting {orgInfo?.name ?? "Financial Institution"}
            </h1>
            <p className="text-slate-500 text-center text-sm mb-[32px]">
              Please wait while a secure connection is established.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
